import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../reusable-components/InputField';
import { required } from '../../../../utils/validations';
import Header from '../../../../reusable-components/Header';
import Footer from '../../../../reusable-components/Footer';
import Body from '../../../../reusable-components/Body';
import Spinner from '../../../../reusable-components/Spinner';
import PageContent from '../../../../reusable-components/PageContent';
import PageHeader from '../../../../reusable-components/PageHeader';
import { Row, Col, Button } from 'react-bootstrap';
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import PropTypes from 'prop-types';
import '../../../../styles/practical.less';

export default class PracticalInformation extends Component {
  render() {
    return (
      <>
        <PageHeader title="Praktische informatie" />
        <PageContent 
          title="Waar wilt u een vergunning voor aanvragen?"
          goBack={() => this.props.history.goBack()}
          moveNext={() => this.props.history.push('/extend/ChooseObject')}
          cardClass="card-container"
          showFooter={true}
          hasNextBtn={true}
          hasBackBtn={true}
          hasSubmitBtn={false}>
        <Row noGutters={true}>
          <Col md={12}>
            <div className="practical-container">
              <ul className="instructions-container">
                <li className="media"><span className="instruction-circle">1</span><span className="instruction-text media-body">Selecteer het objecttype waar u een vergunning voor wilt hebben.</span></li>
                <li className="media"><span className="instruction-circle">2</span><span className="instruction-text media-body">Selecteer de locatie op de kaart</span></li>
                <li className="media"><span className="instruction-circle">3</span><span className="instruction-text media-body">Voer de gegevens in van het object waar u de vergunning voor aanvraagt.</span></li>
                <li className="media"><span className="instruction-circle">4</span><span className="instruction-text media-body">Op basis van de aanwezige gegevens wordt een raming gemaakt van de kosten en krijgt u te zien welke documenten nodig zijn.</span></li>
                <li className="media"><span className="instruction-circle">5</span><span className="instruction-text media-body">Vul uw persoonlijke gegevens in, de aanvullende vragenlijst en sluit het verzoek af.</span></li>
                <li className="media"><span className="instruction-circle">6</span><span className="instruction-text media-body">Na verificatie van de gegevens ontvangt u een bevestiging per mail. En u ontvangt de gegevens voor betaling.</span></li>
              </ul>
            </div>
          </Col>
          {/*<Col md={12}>
            <div className="footer-btn-container">
              <Button 
                className="btn back-btn"
                onClick={() => {
                  this.props.history.goBack();
                }}><span className="arrowLeft"><FaArrowLeft /></span><span className="left-btn-text">Terug</span></Button>
              <Button 
                className="btn continue-btn"
                onClick={() => {
                  this.props.history.push('/step/one/substep/2');
                }}><span className="right-btn-text">Verder</span> <span className="arrowRight"><FaArrowRight /></span></Button>
            </div>
          </Col>*/}
        </Row>
        </PageContent>
      </>
    );
  }
}

PracticalInformation.propTypes = {
  isloading: PropTypes.bool,
  error_message: PropTypes.string,
  formErrors: PropTypes.object,
  initialValues: PropTypes.object,
}

